module.exports = __webpack_public_path__ + "static/ChrisHolsman-96d71d3236a3fdd07019792e31585911.jpg";